import { putMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const UPDATE_SUB_PRACTICE = 'UPDATE_SUB_PRACTICE';
export const UPDATE_SUB_PRACTICE_SUCCESS = 'UPDATE_SUB_PRACTICE_SUCCESS';
export const UPDATE_SUB_PRACTICE_FAILURE = 'UPDATE_SUB_PRACTICE_FAILURE';

// Action Creators
export const updateSubPracticeRequest = () => ({
  type: UPDATE_SUB_PRACTICE,
});

export const updateSubPracticeSuccess = (users) => ({
  type: UPDATE_SUB_PRACTICE_SUCCESS,
  payload: users,
});

export const updateSubPracticeFailure = (error) => ({
  type: UPDATE_SUB_PRACTICE_FAILURE,
  payload: error,
});

// Thunk Function
export const updateSubPractice = (external, body, id) => {
  return async (dispatch) => {
    dispatch(updateSubPracticeRequest());
    try {
      const response = await putMethodWithToken(
        url.updateSubPractice + id + '/',
        body
      );
      if (response?.status === 200 || response?.status === 201) {
        dispatch(updateSubPracticeSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
      }
    } catch (error) {
      dispatch(updateSubPracticeFailure(error?.message));
    }
  };
};
